import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

import { StoryboardsPage } from "./storyboards";

export const CleverStoryExperiencePage: React.FC = () => {
  const navigate = useNavigate();
  const { workspaceId } = useParams<{ workspaceId: string }>();

  const workspaces = useSelector(
    (state: RootState) => state.experiences.workspaces.items,
  );

  useEffect(() => {
    if (!workspaceId && workspaces.length > 0) {
      navigate(`/experiences/${workspaces[0].id}/storyboards`, { replace: true });
    }
  }, [workspaces, workspaceId]);

  if (!workspaceId) {
    return null;
  }

  return <StoryboardsPage />;
};

export default CleverStoryExperiencePage;